import moment from "moment"
import Image from 'next/image'
import { createObjectPagePathname } from "@/services/pathname"
import { getMediaUrl, getAsServerMediaUrl } from "@/services/pathname"
import { levels, accomodationTypes } from "@/services/bafad"
import 'moment/locale/fr'
import { formatPrice } from "@/services/number"
import { getName } from "@/services/aroeven"
import React from "react"
moment.locale('fr')

type CardProps = {
    bafad: Bafad
}

export default function Card({ bafad }: CardProps) {

    return (
        <a className={"vignette -type-1 h-100" + (bafad.availablePlaces === 0 ? ' opacity-50' : '')} href={createObjectPagePathname('Bafad', bafad)}>
            <div className="vignette__image">
                <div className="cardImage">
                    <div className="cardImage__content">
                        {/*<img className="col-12" src={getMediaUrl(bafad.medias.medias[0]?.media.url ?? process.env.NEXT_PUBLIC_BAFAD_DEFAULTIMAGE)} alt="image" loading="lazy"/>*/}
                        <Image
                            className="col-12"
                            src={getAsServerMediaUrl(bafad.medias.filter(media => media.mimeType.indexOf('image/') === 0)[0]?.url ?? '#')}
                            alt="image"
                            width={bafad.medias.filter(media => media.mimeType.indexOf('image/') === 0)[0]?.metadata.width}
                            height={bafad.medias.filter(media => media.mimeType.indexOf('image/') === 0)[0]?.metadata.height}
                            sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
                            quality={50}
                        />
                    </div>
                    <div className="cardImage__leftBadge">
                        <div className="tag">
                            <h3 className="tag-title">{bafad.level in levels ? levels[bafad.level].short : ''}</h3>
                            <div className="tag-tail" />
                        </div>
                    </div>
                </div>
                <div className="bandeau d-flex justify-content-between">
                    <div>
                        <i className="fi fi-rr-user-graduate" />
                        BAFA - BAFD
                    </div>
                    <div className="dates">{moment(bafad.startDate1).format('DD' + (moment(bafad.startDate1).format('M') !== moment(bafad.endDate2 ? bafad.endDate2 : bafad.endDate1).format('M') ? ' MMM' : ''))}-{moment(bafad.endDate2 ? bafad.endDate2 : bafad.endDate1).format('DD MMM')}</div>
                </div>
            </div>
            <div className="vignette__content pt-10">
                <div className="d-flex flex-column justify-content-between h-100">
                    <div>
                        <div className="d-flex justify-content-between">
                            <div className="flex-fill">
                                <p className="text-light-1 lh-12 text-13 mt-5 mb-0">
                                    <i className="fi fi-rr-marker text-primary-4" /> {bafad.accomodation.address.city} ({bafad.accomodation.address.postCode.slice(0, 2)})
                                </p>
                            </div>
                        </div>
                        {bafad.level in levels &&
                            <h4 className="vignette__title py-10">
                                {levels[bafad.level].name}
                            </h4>
                        }
                        {['bafa_qualification', 'bafa_indepth'].includes(bafad.level) === true && bafad.thematicLabel && <div className="type">{bafad.thematicLabel}</div>}
                        {bafad.availablePlaces > 0 ?
                            <>
                                <div className="tarif">à partir de {Math.floor(Math.min(...bafad.accomodationOptions.map(option => option.price)) / 100)}€ par participant</div>
                                {Object.entries(accomodationTypes).filter(([keyAccomodationType, accomodationType]) => bafad.accomodationOptions.map(option => option.accomodationType).includes(keyAccomodationType)).map(([keyAccomodationType, accomodationType], indexAccomodationType) => {
                                    return (
                                        <React.Fragment key={'accomodationType-' + indexAccomodationType}>
                                            <div className="lieudepart">
                                                <i className={accomodationType.icon} />
                                                {accomodationType.name}
                                            </div>
                                        </React.Fragment>
                                    )
                                })}
                                {bafad.availablePlaces < 5 &&
                                    <div className="flex-fill">
                                        <p className="text-light-1 lh-14 text-13 mt-5 mb-0 last-chance">
                                            Dernière{bafad.availablePlaces > 1 && <>s</>} place{bafad.availablePlaces > 1 && <>s</>} disponible{bafad.availablePlaces > 1 && <>s</>}
                                        </p>
                                    </div>
                                }
                            </>
                            :
                            <><div className="badge rounded-pill bg-terracotta fs-6 d-table mt-2">COMPLET</div></>
                        }
                    </div>
                    <div>
                        <div className="organisation d-flex items-start">
                            <div className="flex-center size-20 rounded-full bg-primary-3 mr-5 text-white">
                                <i className="fi fi-rr-home" />
                            </div>
                            <div className='lh-1 mb-5'>
                                Organisé par {getName(bafad.partnershipOf ? bafad.partnershipOf.proposedBy : bafad.proposedBy)}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </a>
    )
}